function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 73.3L196.4 0H99.5v44.8L97 42.7H0v240.8h184v-42.6h99.5V73.3zm-85-34.3l46.1 38.8h-46.1V39zm-70.6-10.5H170v75.6l-42.1-35.4V28.5zM99.1 81.7l46.1 38.8H99.1V81.7zM155.5 255h-127V71.1h42.1V149h85l-.1 106zm28.5-42.7v-96.4l-11.4-9.6H255v106h-71z"
})));